import { db, EntryAttributeDB, ItemTypeDB, UserDB, cats_default } from "@/ts/DexieDB";
import Categories from "./Categories";
import DataBaseTests from "./DataBaseTests";
import CategoryData, { CatDB } from "./DataTypes/CategoryData";

import Entry, { EntryDB } from "./DataTypes/Entry";
import Helpers from "./Helpers";

export default class Data
{
    static cats:Array<CategoryData>;

    static promise_returned:Promise<Array<CategoryData>>;


    static async AddUser(username:string) 
    {
        console.log("adding user ", username);
        let result = await db.users.add(new UserDB({name:username}));

        let user = await db.users.get(result) as UserDB;

        //also add default categories for this user
        for (let i = 0; i < cats_default.length; i++) 
        {
            const cat = {...cats_default[i]};
            (cat as any).id_user=user.id;
            //@ts-ignore
            cat.id=undefined;
            // console.log("populate dexiejs, cats: ", cat)
            await db.cats.add(new CategoryData(cat));
            console.log("finished adding new cat to new user: ", cat);
        }


        console.log("result: ", result, "user: ", user);
        return user;
    }
    //more for loading users from json/ not adding default cats
    static async AddUserNoCats(username:string) 
    {
        console.log("adding user to database", username);
        let result = await db.users.add(new UserDB({name:username}));

        let user = await db.users.get(result) as UserDB;
        console.log("User added: ", result, "user: ", user);
        return user;
    }

    static async UpdateUser(user:any) 
    {
        //get user by timestamp
        console.log("Update USer, looking for user: ", user);
        let user_db = (await db.users.where("timestamp").equals(user.timestamp).toArray())[0];

        let response = (await db.users.update(user_db.id, user));
        console.log("updated user, with response: ", response);
    }

    static async UpdateUserTimeStampFromID(id:string, timestamp:number) 
    {
        let response = (await db.users.update(id, {timestamp:timestamp}));
        console.log("updated user, with response: ", response);
    }
    static async DeleteUser(user:any) 
    {
        console.log("deleting user: ", user);
        await db.users.delete(user.id);

        // dexiejs doesn't have an ability to delete where.... so going to have to find them all, and loop through

        //first categories, 
        let cats = await db.cats.where("id_user").equals(user.id).toArray();
        console.log("deleting cats for user: ", cats);
        for (const cat of cats) 
        {
            await db.cats.delete(cat.id);
        }

        //then entires
        let entries = await db.entries.where("id_user").equals(user.id).toArray();
        console.log("deleting entries for user: ", entries);
        for (const entry of entries) 
        {
            await db.entries.delete(entry.id);
        }

        //item types
        let item_type = await db.item_types.where("id_user").equals(user.id).toArray();
        console.log("deleting item_type for user: ", item_type);
        for (const item of item_type) 
        {
            await db.item_types.delete(item.id);
        }

        //attributes
        let attributes = await db.entry_attributes.where("id_user").equals(user.id).toArray();
        console.log("deleting attributes for user: ", attributes);
        for (const attr of attributes) 
        {
            await db.entry_attributes.delete(attr.id as string);
        }


        console.log("Finished deleting user");
        // let user_db = (await db.users.where("timestamp").equals(user.timestamp).toArray())[0];

        // let response = await (await db.users.update(user_db.id, user));
        // console.log("updated user, with response: ", response);
    }

    static async GetUsers() 
    {
        console.log("getting users");
        let users = (await db.users.toArray());

        let users2= new Array<UserDB>();        
        for (let i = 0; i < users.length; i++) {
            const user = users[i];
            users2.push(new UserDB(user));
        }
        console.log("finished getting users");
        return users2;
    }
    static async GetUserByID(id:string) 
    {
        //can still come in as a string, and error out
        //@ts-ignore
        // id = parseInt(id);

        console.log("getting user: ",id);

        // let users = await db.users.where("id").equals(id).toArray();
        // console.log("done getting user: ",id, "users: ", users);

        let user = (await db.users.where("id").equals(id).toArray())[0];
        console.log("done getting user: ",id, "user: ", user);
        return user;
    }
    //for getting any user, in case one got deleted/ something got messed up
    static async GetFirstUser() 
    {
        let user = (await db.users.toArray())[0];
        console.log("done getting user: ", user);
        return user;
    }
    static async GetUserByTimeStamp(timestamp:number) 
    {
        //can still come in as a string, and error out
        //@ts-ignore
        timestamp = parseInt(timestamp);//comes in as a string from json

        console.log("getting user: ",timestamp);

        // let users = await db.users.where("id").equals(id).toArray();
        // console.log("done getting user: ",id, "users: ", users);

        
        
        let user = await (await db.users.where("timestamp").equals(timestamp).toArray())[0];
        console.log("done getting user: ",timestamp, "user: ", user);
        return user;
    }

    static async AddCat(cat_obj:object)
    {
        let result = await db.cats.add(new CatDB(cat_obj));
        let cat = await db.cats.get(result) as CatDB;
        //add it in memory too:

        let cat_data= new CategoryData(cat);
        if(Data.cats)
        {
            Data.cats.push(cat_data);
        }

        return cat_data;
    }
    static async UpdateCat(cat_obj:any) 
    {
        console.log("updated cat, cat_obj: ", cat_obj);
        //get user by timestamp
        // let cat_db = (await db.cats.where("timestamp").equals(cat_obj.timestamp).toArray())[0];
        // console.log("update cat, cat_db found from timestamp: ", cat_db);

        // let cat_db2 = (await db.cats.where("id").equals(cat_obj.id).toArray())[0];
        // console.log("update cat, cat_db found from id: ", cat_db2);

        let response = await (await db.cats.update(cat_obj.id, cat_obj));
        console.log("updated cat, with response: ", response);

        //should also update this cat in data, so it's reflected
        if(Data.cats)//if it has been loaded- won't be while importing json for the first time
            for (let i = 0; i < Data.cats.length; i++) 
            {
                const cat = Data.cats[i];
                if(cat.timestamp==cat_obj.timestamp)
                {
                    Data.cats[i] = {...cat_obj};
                    console.log("cat updated in memory a well", Data.cats[i]);
                }
            }
        
    }

    //get categories, sorted By last updated
    static async GetCategories(id_user:string, going_to_use_GetEntriesByDateRange:boolean)
    {
        // console.error("only do this once, or cat.entries get removed");
        
        console.log("get categories, where user id: ",id_user)

        // console.log("ERROR: DATA: GOING TO RETURN WHILE WORKING ON DATABASE- UNCOMMENT TO GET WORKING AGAIN")
        // return;
        // console.warn("Calling get cats for user id: ", id_user);

        // console.log("getting categories")
        
        // console.log("getting categories, not defined yet")
        // let delay=1;

        //to cache getting user data

        // if(Data.cats)
        //     return Data.cats;

        // if(Data.promise_returned)
        //     return Data.promise_returned;

        //actually grab categories from database
        
        Data.promise_returned = new Promise<Array<CategoryData>>(async(resolve, reject) => 
        {
            let cats_from_db = await db.cats.where("id_user").equals(id_user).toArray();

            cats_from_db.map((element:any)=>{
                let new_ele = {...element, entries:new Array<Entry>()} ;
                new_ele = new_ele as CategoryData;
                return {...element, entries:new Array<Entry>()} as CategoryData;
            }
                );

                //should also sort by date- newest first
                cats_from_db.sort(function(a:any,b:any){
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.date_updated).getTime() - new Date(a.date_updated).getTime() ;
                });

            console.log("cats from database: ", cats_from_db)
            
            
            Data.cats=cats_from_db as Array<CategoryData>;

            //should load all the tables:
            //cats, item_types, entires, attributes

            // await Data.LoadEntries()
                
            resolve(Data.cats);

            // console.log("done getting  categories")

        });
        // console.warn("cats: ", Data.promise_returned);
        return Data.promise_returned;


        //wait like 2s, then returhn categories- fake grabbing it from database before adding the real stuff
        // Data.promise_returned = new Promise<Array<CategoryData>>((resolve, reject) => {
        //     setTimeout(async () => 
        //     {
                

        //         let cats = new Array();
        //         Categories.icons.forEach((cat, i)=>{
                    
        //             // cats.push(new CategoryData(i, undefined, cat.name, cat.bg_color, cat.txt_color, cat.icons[0]));
        //         });
        //         Data.cats=cats;

        //         await Data.LoadEntries()
                
        //       resolve(cats);

        //       console.log("done getting  categories")

        //     }, delay);
        //   });

        //   return Data.promise_returned;
    }
    static async LoadEntries()
    {
        //should clear out entries on cats, and add new ones
        // Data.cats.entries2 = new Array<Entry>();

        let entries_from_db = await db.entries.toArray();
        console.log("entries from database: ", entries_from_db)

        entries_from_db.forEach((entry_db:any)=>{

            let entry = new Entry({id:entry_db.id as string, /* name:entry_db.name, */ date_updated:entry_db.date_updated});

            Data.cats.forEach((cat)=>{
                if(cat.id==entry_db.id_cat)
                    cat.entries.push(entry);
            });
        
        });
    }

    /*
        Create an Object basaed on entries- should also go through and grab the things related to an entry- the item type and any item attributes
        this just updates the current cats object with entries
    */
    static async GetEntriesByDateRange(date_start:Date, date_end:Date, id_user:string)
    {
        // id_user = Helpers.ForceInt(id_user);


        //should clear out entries on cats, and add new ones
        // Data.cats.entries2 = new Array<Entry>();
        for (let i = 0; i < Data.cats.length; i++) 
        {
            const cat = Data.cats[i];
            cat.entries = new Array<Entry>();            
        }
        // console.log("GetEntriesByDateRange, Data.cats: ",Data.cats)

        // let date_start_ms=date_start.getTime();
        // let date_end_ms=date_end.getTime();
        //first get all the entries for a date range
        // console.log("GetEntriesByDateRange ",date_start, date_end, "as number", date_start, date_end);
        // let entries_from_db = await db.entries.toArray();
        // let entries_from_db = await db.entries.where("date_updated").between(date_start, date_end).toArray();

        //to sort by newest first- returns an array, like "to array"

        
        //should be able to do multiple queries/ find by user and date range like this, but can't- have to have compound indexes if we want to:
        // https://stackoverflow.com/questions/58050422/write-multiple-where-condition-using-dexie-js

        // let entries_from_db = await (await db.entries.where("date_updated").between(date_start, date_end).where("id_user").equals(id_user).sortBy("date_updated")).reverse();
        
        let entries_from_db = await (await db.entries.where("date_updated").between(date_start, date_end).sortBy("date_updated")).reverse();
        //https://stackoverflow.com/questions/58050422/write-multiple-where-condition-using-dexie-js

        //so instead we'll just manually filter afterwards for now:
        // entries_from_db.filter((entry)=>{
        //     if(entry.id_user==id_user)
        //         return entry;
        // });

        //manually filter out only the user entries we want
        console.log("entries for date range length: ", entries_from_db.length);
        let entries_for_user= new Array();
        for (let i = 0; i < entries_from_db.length; i++) {
            const entry = entries_from_db[i];
            // console.log("looking at entry in date range: ", entry, "and checking if id ==",entry.id_user, " ==", id_user, (entry.id_user==id_user));
            if(entry.id_user==id_user)
            {
                console.log("Ids are equal!");
                entries_for_user.push(entry);
            }
        }
        entries_from_db= entries_for_user;


        // console.log("GetEntriesByDateRange entries_from_db1",entries_from_db);
        
        //map finishes after the rest of the program/ keeps going and doesn't await vs. an actual for loop
        // await entries_from_db.map(async (entry)=>{

        // await Promise.all(entries_from_db.map(async (entry)=>{ //Promise. all forces map to finish before moving onto the next line: https://medium.com/@nyablk97/array-map-async-await-160b66f7180e - like a for loop does, so lets it work syncronoysly
        for (let i = 0; i < entries_from_db.length; i++) 
        {
            const entry = new Entry(entries_from_db[i]);//entry also has the item name, gained from item_types
        
            //get item_type for the entry, and add it
            entry.item_type = (await db.item_types.get(entry.id_item_type))?.name||"couldn't find item name with id: "+entry.id_item_type;
            // console.log("entry.item_type: ", entry.item_type, entry);

            //also grab any attributes for this entry:
            // let attributes="";
            // let attributes = await db.entry_attributes.where("id_entry").equals(entry.id).toArray();
            let attributes = await Data.GetAttributesForEntryID(entry.id);
            // console.log("attributes for entry", attributes);

            //dexiejs doesn't like: id_item_type/ can't index it
            // let attributes = await db.entry_attributes.where("id_item_type").equals(0).toArray();

            // let attributes = await db.entry_attributes.where("id_entry").equals(entry.id).first();
            entry.attributes = attributes;

            // if(attributes.length>0)
            //     console.log("attributes: ", attributes);

            //add this entry to the cat
            // console.log("Getting category by entry.id_cat: ", entry.id_cat);
            Data.GetCategoryById(entry.id_cat)?.entries.push(entry);

            
            // return entry;
        };//for an array
        // }));//for map
        // console.log("done");

        // console.log("GetEntriesByDateRange Data.cats",Data.cats);

        //should get each item_type for each entry

        //should get any entry atttributes for each entry //entry_attributes

        //return the cats with the entries in them
        // console.log("GetEntriesByDateRange, Data.cats: ",Data.cats)
        return Data.cats;
        
    }

    static async GetItemTypesRecent(id_user:string, count:number)
    {
        let item_types_from_db = await (await db.item_types.where("id_user").equals(id_user).reverse().limit(count).toArray());

        //manually filter out only the user entries we want
        let item_types_for_user= new Array();
        for (let i = 0; i < item_types_from_db.length; i++) {
            const entry = item_types_from_db[i];
            if(entry.id_user==id_user)
                item_types_for_user.push(entry);
        }
        item_types_from_db= item_types_for_user;
        console.log("GetItemTypesRecent entries_from_db1",item_types_from_db);
        return item_types_from_db;        
    }
    static async GetAttributesForEntryID(id_entry:string)
    {
        // console.log("GetAttributesForEntryID: ", id_entry);
        let attributes = await db.entry_attributes.where("id_entry").equals(id_entry).toArray();
        // console.log("GetAttributesForEntryID: found attributes for ", id_entry, attributes);
        return attributes;
    }
    static async GetAttributeCountByTimestamp(timestamp:number)
    {
        let attr_w_timestamp= await db.entry_attributes.where("timestamp").equals(timestamp).toArray();
        // console.log("found attr with timestamp: ", timestamp, attr_w_timestamp)
        let count =  (attr_w_timestamp).length;

        return count;
    }

    static async GetEntryById(id:string)
    {
        // console.log("looking for entry id: ", id);
        let entry =  (await db.entries.where("id").equals(id).toArray())[0];
        // console.log("entry found is: ", entry);

        return entry;
    }

    //id cat is for checking if their is 2 entries with the same date, check if id cat is the same
    static async GetEntryByDateUpdated(date:Date, id_item_type?:string)
    {
        console.log("looking for entry date: ", date);

        //DEXIEjs stores dates in UNIX epoch time format, so can't match it to the second if stored further than 1s/ milliseconds. SO have to do dat erange
        // let entries = await (await db.entries.where("date_updated").equals(date).toArray());

        let date_start = new Date(date);
        date_start.setSeconds(date.getSeconds()-1);

        let date_end = new Date(date);
        date_end.setSeconds(date.getSeconds()+1);
        

        let entries = await (await db.entries.where("date_updated").between(date_start, date_end).toArray());
        console.log("entries for date: ", entries, "length: ", entries.length);
        let entry=undefined;
        if(entries.length==1)
            entry= entries[0];
        else
        {
            for(let entry1 of entries)
            {
                if(entry1.id_item_type==id_item_type)
                    entry=entry1;
            }
        }

        console.log("entries found is: ", entry);

        return entry;
    }

    static async GetEntryByTimeStamp(timestamp:number)
    {
        console.log("looking for entry date: ", timestamp);
        let entries = (await db.entries.where("timestamp").equals(timestamp).toArray());
        if(entries.length>1)
            console.error("\n\n\n\n\nERROR: found more than one entry with timestamp: ", timestamp, entries);
        let entry = entries[0];
        console.log("entries found is: ", entry);

        return entry;
    }
    static async GetEntryCountByTimestamp(timestamp:number)
    {
        let count = (await db.entries.where("timestamp").equals(timestamp).toArray()).length;
        return count;
    }

    static async GetItemTypeByName(name:string, id_user:string)
    {
        console.log("looking for item type : ", name);
        let item_types = await (await db.item_types.where("name").equals(name).toArray());
        //need to also check if the user ID is the same
        let item_type = undefined as any;
        for(let item_type_temp of item_types)
        {
            if(item_type_temp.id_user == id_user)
            {
                item_type = item_type_temp
                break;
            }
        }
        console.log("entry item type is: ", item_type);

        return item_type;
    }
    static async GetItemTypeByNameAndUserID(name:string, id_user:string)
    {
        console.log("looking for item type : ", name);
        let item_type = await (await db.item_types.where("name").equals(name).toArray())[0];
        console.log("entry item type is: ", item_type);

        return item_type;
    }
    static async CreateItemType(name:string, id_cat:string)
    {
        //{id:0, id_cat:0, name:"Milk", date_updated:DataBaseTests.GetDate(-22)/*
        console.log("Data: CreateItemType, creating with name: ",name, "id cat: ", id_cat);
        let item_type = new ItemTypeDB({});
        item_type.name=name;
        item_type.date_updated = new Date();
        item_type.id_cat = id_cat;
        let new_item_id:string = await db.item_types.add(item_type) as string;

        console.log("Data: CreateItemType, created with return: ", new_item_id);
        return new_item_id;
    }

    static GetCategoryById(id:string)
    {
        // console.log("looking for cat id: ", id);
        for (let i = 0; i < Data.cats.length; i++) 
        {
            const cat = Data.cats[i];
            if(cat.id==id)
            {
                // console.log("found cat!", cat);
                return cat;
            }
        }
        console.log("cat not found");
        throw new Error("could not find cat by id given: "+ id);
    }

    static async GetCategoryByUserIdAndCatName(id_user:string, cat_name:string)
    {
        console.log("looking for cat: ", cat_name, "userID: ", id_user);
        let cats = (await db.cats.where("name").equals(cat_name).toArray());
        
        let cat_final=undefined;
        for (let cat of cats)
        {
            if(cat.id_user==id_user)
            {
                cat_final=cat;
                break;
            }
        }
        if(!cat_final)
            console.log("GetCategoryByUserIdAndCatName: cat not found");
        // else
        //     console.log("GetCategoryByUserIdAndCatName: cat found", cat_final);
    
        return cat_final;
    }

    static async GetCategoryByTimestamp(timestamp:number)
    {
        console.log("looking for cat timestamp: ", timestamp);
        let cat = (await db.cats.where("timestamp").equals(timestamp).toArray())[0];
        if(!cat)
            console.log("GetCategoryByUserIdAndCatName: cat not found");
        // else
        //     console.log("GetCategoryByUserIdAndCatName: cat found", cat_final);
    
        return cat;
    }
    static async GetCategoriesCountByTimestamp(timestamp:number)
    {
        let count = (await db.cats.where("timestamp").equals(timestamp).toArray()).length;
        return count;
    }

    /*
    For getting the previous entry names for a given category. 
    right now, dexiejs can't grab by date ac, then limit- it limits, then arranges by date, so doesn't work quite right
    would have to change how they are indexed in dexie to allow it, but will wait on that
    https://github.com/dexie/Dexie.js/issues/867
    */
     static async GetPrevItemTypesForCat(cat_id:string, offset:number=0, count:number=10000):Promise<Array<ItemTypeDB>>
    {
        //the entries are actually in item_types, and have their own last updated + cat_id value.
        //so just need to get item_types by cat_id
        //sort by last updated
        //get only X amount, offset by y amount

        // let entries_from_db = await (await db.item_types.where("date_updated").between(date_start, date_end).sortBy("date_updated")).reverse();
        let prev_item_types = (await db.item_types.where("id_cat").equals(cat_id).offset(offset).limit(count).sortBy("date_updated"));

        //PROBLEM WHEN TESTING OFFSET=1, LIMIT 3- it grabs the limit, then sorts by date- so cant grab from DB by date arranged, then grab a limited amount of those. 
        //would have to have them entered in DB in order, or:
        //https://github.com/dexie/Dexie.js/issues/867
        //have to have id + date in compound index to be able to sort by date [so can grab a certain date + id_cat]- either that or be cool with grabbing all entires, then limiting them
        // let prev_entries = await (await db.item_types.where("id_cat").equals(cat_id).toArray());
        console.log("Data: GetPrevItemTypesForCat", prev_item_types);
        return prev_item_types;

    }
    static async GetPrevAttributesForCat(cat_id:string, offset:number=0, count:number=10000):Promise<Array<EntryAttributeDB>>
    {

        let prev_attr = (await db.entry_attributes.where("id_cat").equals(cat_id).offset(offset).limit(count).sortBy("date_updated"));

        console.log("Data: GetPrevAttributesForCat", prev_attr, "cat_id: ", cat_id);
        return prev_attr;

    }

    
    static async AddEntryOld(cat:CategoryData, text:string)
    {
        try 
        {
            let entry =new Entry({id:-1, name:text});
            (Data.GetCategoryById(cat.id) as CategoryData).entries.push(entry);
            // Add the new friend!
            // let entry = cat.entries[cat.entries.length-1];
            let date_updated =  entry.date_updated;

            console.log("ERROR: commenting out adding entry, since new format");
            // const id = await db.entries.add({
            // name: text,
            // date_updated:date_updated,
            // cat_id:cat.id
            // });
            // entry.id=parseInt(id.toString());


            // console.log("Entry got added to the database!", id, "entry.id: ", entry.id);
            // this.status = `Friend ${this.friendName}
            // successfully added. Got id ${id}`;

            // Reset form:
            // this.friendName = '';
            // this.friendAge = this.defaultAge;
        } catch (error) {
            // this.status = `Failed to add
            // ${this.friendName}: ${error}`;
            console.log("Error instering entry into database", error)
        }
    }

    //the cat and entry index, as well as the entry id
    static async DeleteAttribute(attr:EntryAttributeDB)
    {
        console.log("DeleteAttribute: going to delete attribute: ", attr);
        await db.entry_attributes.delete(attr.id as string);

        //need to also delete from cached data
        //though the cached data doesn't have entries on it....
        this.GetCategoryById(attr.id_cat).entries.forEach(entry => {
            if(entry.id== attr.id_entry)
            {
                console.log("DeleteAttribute: entry attributes before: ", entry.attributes);
                if(entry.attributes)
                entry.attributes = entry.attributes.filter(attr2 => {
                    if(attr.id!=attr2.id)
                        return attr2;
                    else
                        console.log("DeleteAttribute: found attribute in entry in memory, and getting rid of it", attr2);
                });
                console.log("DeleteAttribute: entry attributes afterwards: ", entry.attributes);
            }
            
        });
    }

    //the cat and entry index, as well as the entry id
    static async DeleteEntry(extra_info:Object)
    {
        console.log("DeleteEntry: got passed object: ", extra_info);
        let info = extra_info as DeleteEntryInterface;

        //cat index doesn't work- have to grab actual cat id
        // console.log("DeleteEntry: info.cat_index", info.cat_index, Data.cats[info.cat_index]);
        // console.log("DeleteEntry: Data.cats[info.cat_index].entries.length1: ", Data.cats[info.cat_index].entries.length);
        // Data.cats[info.cat_index].entries.splice(info.entry_index, 1);
        //vue doesn't detect when the sub array changes- just the array, so causes an issue

        let entry_id = (extra_info as any).entry_id;
        let entry = await Data.GetEntryById(entry_id);
        let cat_id = entry.id_cat;
        let cat =  Data.GetCategoryById(cat_id);

        console.log("DeleteEntry: cats ", Data.cats);

         console.log("DeleteEntry: cat ", cat);
        // cat.entries.splice(info.entry_index, 1);
        cat.entries = cat.entries.filter(entry => {
            if(entry_id!=entry.id)
                return entry;
            else
                console.log("DeleteEntry: found entry in memory, and getting rid of it", entry);
        });

        // console.log("DeleteEntry: Data.cats[info.cat_index].entries.length2: ", Data.cats[info.cat_index].entries.length);

        //delete from database
        // console.log("entry index: ",info.entry_id)
        // let result = await db.entries.where('id').equals(info.entry_id).toArray();
        // console.log("result: ", result);

        let entries_from_db = await db.entries.where('id').equals(info.entry_id).delete().then(function (deleteCount:any) {
            console.log( "Deleted " + deleteCount + " objects");
        }).catch ((e:any) => 
            {
            console.error (e);
        });

        // console.log("entries_from_db: ",entries_from_db);
        // Data.cats.forEach((cat, i)=>{
        
        //     //should do both of these backwards- or at least entires for deleting
        //     cat.entries.forEach((entry, j)=>{
        //         if(entry.id==id)
        //             cat.entries.splice(j,1);
            
        //     });
        // });
    }

    //when importing from file- we shouldn't update the date it was last edited, or it will give the wrong date
    static async AddEntry(entry:Object, dont_update_cat_date:boolean=false)
    {
        console.log("Data, going to submit NEW entry: ", entry);

        
        /* 
        id!: number;
        id_user!:number;
        id_cat!:number;
        id_item_type!:number;
        // item_type?:string="";
        date_updated!: Date;
        date_finished: Date|undefined;
        attributes?:undefined|Array<EntryAttributeDB>;
        has_duration:boolean=false; //for if the entry has a duration/ will keep track of time passed
        */
       
        let entry_db = new EntryDB(entry);
        //have to change attributes to actual attributes, not the proxy stuff
        let attrs = new Array<EntryAttributeDB>();
        if(entry_db.attributes)
            for (let i = 0; i < entry_db.attributes.length; i++) 
            {
                const element = entry_db.attributes[i];
                attrs.push(new EntryAttributeDB().Assign(element));
                
                //for keeping the exact same timestamp to the millisecond
                if(element.timestamp)
                    attrs[attrs.length-1].timestamp=element.timestamp;
            }
        //have to wipe out attributes- since not storing that way, storing them in their own table
        entry_db.attributes =[];

        console.log("entry is: ", entry_db, "attrs: ", attrs);

        //have to insert item_type if it doesn't exist/ == -1
        let id_item_type = entry_db.id_item_type;
        if(entry_db.id_item_type=="-1")
        {
            /* 
            id!: number;
            id_user!:number;
            id_cat!:number;
            name!: string;
            date_updated!: Date;
            */
           let item_type_obj = {id_user:entry_db.id_user, id_cat:entry_db.id_cat, name:(entry as any).item_type, date_updated:(entry as any).date_updated};
           console.log("adding item_type_obj: ", item_type_obj);
            let item_type = new ItemTypeDB(item_type_obj);

            console.log("actual item: after copying ", item_type);
            
            id_item_type = (await db.item_types.add(item_type) as string);
            entry_db.id_item_type = id_item_type;
            
        }


        //so first have to insert the entry
        let id_entry = (await db.entries.add(entry_db) as string);
        console.log("entry inserted into db: ", id_entry);
        

        //TODO: then add the entrys id to the attributes, and insert them
        for (let i = 0; i < attrs.length; i++) 
        {
            const attr = attrs[i];
            //need to change id to undefined,
            attr.id=undefined;
            //add entry id,
            attr.id_entry=id_entry;
            //add item_type id
            attr.id_item_type=id_item_type;


            let id_attr = (await db.entry_attributes.add(attr) as string);
            attr.id=id_attr;
            console.log("added attr : ", attr, "id: ", id_attr, "timestamp: ", attr.timestamp);

            //get the attriute- check the timestamp- dexiejs seems to keep rounding
            let attr_db= (await db.entry_attributes.where("id").equals(id_attr).toArray())[0]
            console.log("attr_db : ", attr_db, "timestamp: ", attr_db.timestamp, "are they equal? :", (attr_db.timestamp==attr.timestamp));

            //can try again to set the timestamp and see if it sticks

            // let response = await (await db.entry_attributes.update(attr.id, attr));
            // console.log("updated cat, with response: ", response);
            // //get the attriute- check the timestamp- dexiejs seems to keep rounding
            // attr_db= (await db.entry_attributes.where("id").equals(id_attr).toArray())[0]
            // console.log("attr_db2 : ", attr_db, "timestamp: ", attr_db.timestamp, "are they equal? :", (attr_db.timestamp==attr.timestamp));

        }
        //should be all done, but have to return everything/ update everything?

        //update the cat that it's been updated as well:
        //should update the date updated on the cat as well


        if(!dont_update_cat_date)//only update the cat updated date if we're adding a new entry- not for importing an existing one from json
        {
            let response = await (await db.cats.update(entry_db.id_cat, {date_updated:new Date}));
            console.log("Updated how many cats :", response);
        }


        return entry_db;
        //add it, but then also have to 
        // let result = await db.users.add(new UserDB({name:username}));

        // let user = await db.users.get(result) as UserDB;
    }

    
    static async UpdateEntry(extra_info:Object, dont_update_cat_date:boolean=false)
    {
        //could also pass the entry directly- need to be ready for that
        if(!(extra_info as any).entry)
        {
            let entry = {...extra_info};
            (extra_info as any).entry=entry;
        }

        console.log("UpdateEntry: got passed object: ", extra_info);
        let info = extra_info as UpdateEntryInterface;
        let entry_in = new Entry(info.entry);
        entry_in.timestamp=info.entry.timestamp;

        let entry_id = entry_in.id;
        let item_type = entry_in.item_type;
        let id_item = entry_in.id_item_type;
        let id_cat = entry_in.id_cat;

        let date_updated = entry_in.date_updated;
        let date_finished = entry_in.date_finished;

        let attributes = entry_in.attributes as Array<EntryAttributeDB>;


        console.log("DATA: UpdateEntry: got passed entry: ", entry_in, "item_type: ", item_type, "id_item", id_item, "attributes: ", attributes);

        //check to see if anything has changed- first check if item type has changed
        // let item_type_changed =false;
        let entry = await Data.GetEntryById(entry_id);
        if(!entry)//shouldn't happen when updating an entry, but will output if it does
            console.error("entry found is undefined- using entry id: ", entry_id, "item type: ", item_type)

        
        let item_type_changed = await Data.CheckIfEntryNameOrCatChanged(entry, id_item, item_type, id_cat);
        let date_changed = await Data.CheckIfEntryDatesChanged(entry, date_updated, date_finished);

        //for updating timestamps if duplicates....
        let timestamp_changed = entry.timestamp!=entry_in.timestamp;

        let original_attributes = await Data.GetAttributesForEntryID(entry.id);

        //attributes are different- if changed, update them in the attributes table, add them if they don't exist
        if(attributes)
            await Data.UpdateAttributesIfChanged(original_attributes, attributes);

        console.log("Finished checking if things changed, entry: ", entry, "attributes: ", attributes);

        //the item type has changed- either with an id (not -1) or with a known one

        let entry_updated = {};
        let entry_changed=false;

        if(item_type_changed.changed)
        {
            entry_changed=true;
            (entry_updated as any).id_item_type = entry.id_item_type;

            //if cat was changed
            (entry_updated as any).id_cat = entry.id_cat;
            // let response = await (await db.entries.update(entry.id, {id_item_type:entry.id_item_type}));
            // console.log("Updated how many items :", response);
        }
        if(date_changed.changed)
        {
            entry_changed=true;
            (entry_updated as any).date_updated = entry.date_updated;
            (entry_updated as any).date_finished = entry.date_finished;
            console.log("date changed, new object: ", entry_updated);
        }
        if(timestamp_changed)
        {
            entry_changed=true;
            (entry_updated as any).timestamp = entry_in.timestamp;
            console.log("timestamp changed, new object: ", entry_updated);
        }
        if(entry_in.tracking!=entry.tracking)
        {
            entry_changed=true;
            (entry_updated as any).tracking = entry_in.tracking;
            console.log("tracking changed, new object: ", entry_updated);
        }

        //attributes are different- if changed, update them in the attributes table, add them if they don't exist
        /* if(attributes_changed)
        {
            // entry_changed=true;
            
            let attr_non_proxy = new Array<EntryAttributeDB>();
            //attributes is a vue proxy still - have to somehow turn them back into actual objects
            for (let i = 0; i < attributes.length; i++) {
                const attr = attributes[i];

                attr_non_proxy.push(new EntryAttributeDB().Assign(attr))
                // console.log(`attr[${i}]:`, attr.id)
                
            }
            // (entry_updated as any).attributes = attr_non_proxy;
            //attributes shouldn't be put on the entry- if changed, they need to be updated in attributes table
            console.log("attributes changed, new object: ", entry_updated, "attributes: ", attr_non_proxy);
        } */



        if(entry_changed)
        {
            let response = await (await db.entries.update(entry.id, entry_updated));
            console.log("Updated how many entrys :", response);

            //should update the date updated on the cat as well
            response = await (await db.cats.update(entry.id_cat, {date_updated:new Date}));
            console.log("Updated how many cats :", response);
        }


        //so if item id is -1, it's not a prev item id that was clicked, but one that was typed out.
        //should still check to see if it already exists, use that id if it does, if not, create a new item type

        //so first have to check if entry name(item_type) changed, if so, check if it already exists, and use that ID- if not, create a new item type
        // Data.cats[info.cat_index].entries.splice(info.entry_index, 1);

        // let result = await db.entries.where('id').equals(info.entry_id).toArray();

        /* let entries_from_db = await db.entries.update(info.entry_id,{name:info.entry.item_type, date_updated:info.entry.date_updated}).then(function (count) {
            console.log( "Updated " + count + " objects");
        }).catch (e => {
            console.error (e);
        });
        console.log("entries_from_db: ",entries_from_db); */

    }

    //internal use- to check if entry name changed when updating an entry, returning something like:
    //{changed:true, id_item_type:id}
    static async CheckIfEntryNameOrCatChanged(entry:EntryDB, id_item:string, item_type:string, id_cat:string)
    {
        let response = {changed:false, id_item_type:"-1"};
         //the item type has changed- either with an id (not -1) or with a known one
         if(entry.id_item_type!=id_item)
         {
             console.log("item type has changed!");            
             if(id_item!="-1") //if it is known, just change the entry item_type_id
             {
                 entry.id_item_type=id_item;
             }
             else //if it is unknown (-1), look for it in the database- if not there, create it
             {
                 let item_type_db = await Data.GetItemTypeByName(item_type, entry.id_user); 
                 if(item_type_db)//if it exists already, just use it
                 {
                     entry.id_item_type=item_type_db.id;
                 }
                 else //otherwise, create a new item type, and use that
                 {
                     let new_item_id = await Data.CreateItemType(item_type, id_cat);
                     entry.id_item_type = new_item_id;
                 }
             }
             response.changed=true;
             response.id_item_type=entry.id_item_type;
 
            //  let response = await (await db.entries.update(entry.id, {id_item_type:entry.id_item_type}));
            //  console.log("Updated how many items :", response);             
         }
         else if(entry.id_cat!=id_cat)
        {
            console.log("item cat has changed!");
            entry.id_cat=id_cat;
            response.changed=true;
        }
         else
             console.log("item type has NOT changed!");

        return response;
    }

    //internal use- to check if entry date changed when updating an entry, returning something like:
    //{changed:true, id_item_type:id}
    static async CheckIfEntryDatesChanged(entry:EntryDB, date_updated:Date, date_finished:Date|undefined)
    {
        let response = {changed:false};

        let date_updated_changed = entry.date_updated.getTime()!=date_updated.getTime();

        //date finished could be undefined, so have to do a bunch of extra checks
        let date_finished1 = entry.date_finished;
        let date_finished2 = date_finished;
        let date_finished_changed=false;
        if(date_finished1)//date1 defined
        {
            date_finished_changed=true;//will be true if the next part doesn't change it

            if(date_finished2) //date2 defined
            {
                date_finished_changed = (date_finished1.getTime()!=date_finished2.getTime());
                console.log("date_finished_changed: ",date_finished_changed,", they don't equal each other: date1: ", date_finished1.getTime(), "date2: ", date_finished2.getTime());
            }
        }
        else //date1 undefined
        {
            if(date_finished2) //date2 defined
                date_finished_changed=true;
        }
        

        //have to use date.getTime() to check if equal- even same dates are not equal, since 2 different objects
         if(date_updated_changed|| date_finished_changed)
         {
            console.log("item date has changed!");
            console.log("date updated changed?", date_updated_changed, "entry.date_updated: ", entry.date_updated, "date_updated: ", date_updated);
            console.log("date finished changed?", (date_finished_changed), "entry.date_finished: ", entry.date_finished, "date_updated: ", date_finished);

            //  console.log("item date has changed!, data updated changed?: ", (entry.date_updated!=date_updated), "date finished changed?",(entry.date_finished!=date_finished) );
             entry.date_updated=date_updated;
             entry.date_finished=date_finished;

             response.changed=true;    
         }
         else
             console.log("Entry date has NOT changed!");

        return response;
    }

    static async UpdateAttribute(attribute_obj:any) 
    {
        //get user by timestamp
        let user_db = (await db.entry_attributes.where("timestamp").equals(attribute_obj.timestamp).toArray())[0];

        let response = await (await db.entry_attributes.update(attribute_obj.id, attribute_obj));
        console.log("updated attribute_obj, with response: ", response);
    }

    //internal use- to check if entry date changed when updating an entry, returning something like:
    //{changed:true, id_item_type:id}
    static async UpdateAttributesIfChanged(original_attributes:Array<EntryAttributeDB>, new_attributes:Array<EntryAttributeDB>)
    {
        //if all the new attributes were found
        let attributes_added= new Array<EntryAttributeDB>();
        for (let i = 0; i < new_attributes.length; i++) 
        {
            const attr_new = new_attributes[i];
            //if exists, update in database
            
            let exists=false;
            for (let j = 0; j < original_attributes.length; j++) 
            {
                const attr_old = original_attributes[j];
                if(attr_old.id==attr_new.id)
                {
                    exists=true;
                    //it already exists- check if anything has changed and update in database if it has
                    if(attr_old.name!==attr_new.name||attr_old.value!==attr_new.value||attr_old.rating!==attr_new.rating)
                    {
                        let response = await (await db.entry_attributes.update(attr_new.id as string, attr_new));
                        console.log("Updated entry attribute :", response);
                    }
                }
                
            }
            if(!exists)
                attributes_added.push(attr_new);
        }

        // add any new ones
        if(attributes_added.length>0)// new ones were added
        {
            for (let i = 0; i < attributes_added.length; i++)
            {
                const attr_new = attributes_added[i];
                attr_new.id=undefined;
                //add to database
                console.log("adding new attribute to database! ", attr_new);
                await db.entry_attributes.add(new EntryAttributeDB().Assign(attr_new));

            }
        }

        //check for any deletions
        //delete any that no longer exist
        // let attributes_deleted= new Array<EntryAttributeDB>();
        for (let j = 0; j < original_attributes.length; j++)
        {
            const attr_old = original_attributes[j];

            let old_found=false;
            for (let i = 0; i < new_attributes.length; i++) 
            {
                const attr_new = new_attributes[i];
                if(attr_old.id==attr_new.id)
                {
                    old_found=true;
                    break;
                }
            }
            if(!old_found)
            {
                // attributes_deleted.push(attr_old);
                //TODO: delete from the database
                console.log("data found deleted attribute, attribute ", attr_old);

                // let response = await (await db.entry_attributes.update(attr_new.id as number, attr_new));
                let response = await (await db.entry_attributes.delete(attr_old.id as string));
                console.log("Updated entry attribute :", response);
            }
            
            
        }



        


       /*  let response = {changed:false};
        if(!original_attributes&&attributes)//if there was no attributes, and now there is
        {
            response.changed=true;
        }
        else if(original_attributes&&!attributes.length)//if new attributes no longer exist
        {
            response.changed=true;
        }
        else if(original_attributes&&attributes.length!=original_attributes.length) //if it does exist, and lengths changed
            response.changed=true;
        else if(original_attributes) //both exist, and both same length
        {
            for (let i = 0; i < attributes.length; i++) 
            {
                const attr = attributes[i];
                const attr_old = original_attributes[i];
                if(attr.id!=attr_old.id)
                {
                    response.changed=true;
                    break;
                }
                else if(attr.name!=attr_old.name)
                {
                    response.changed=true;
                    break;
                }
                else if(attr.value!=attr_old.value)
                {
                    response.changed=true;
                    break;
                }
                else if(attr.rating!=attr_old.rating)
                {
                    response.changed=true;
                    break;
                }
            }
        }

        if(response.changed)
            console.log("at least one attribute was changed, goign to update");


        return response; */
    }

    
}




interface DeleteEntryInterface {
    cat_index: number,
    entry_index: number,
    entry_id: number,
}
interface UpdateEntryInterface {
    cat_index: number,
    entry_index: number,
    entry_id: number,
    entry:Entry
}